<script setup>
import { tv } from 'tailwind-variants';

const props = defineProps({
  isRequired: {
    type: Boolean,
    default: false,
  },
  for: {
    type: String,
    default: '',
  },
});

const formLabelRecipe = tv({
  base: 'text-sm text-brand-text',
  variants: {
    isRequired: {
      true: 'after:text-brand-red-12 after:-ml-0.5 group-data-[required=true]:after:content-["*"] data-[required=true]:after:content-["*"]',
    },
  },
  defaultVariants: {
    isRequired: false,
  },
});
</script>

<template>
  <label
    data-component="CsFormLabel"
    :data-required="props.isRequired || undefined"
    :for="props.for || undefined"
    :class="formLabelRecipe({ isRequired: props.isRequired })"
  >
    <slot />
  </label>
</template>
